import picomatch from 'picomatch'
import { uniqueId } from 'lodash'

function initFeedbackInjector() {
  const programId = $('#current_user_data').data('program-id')

  SOPHIA.ajax({
    data: {
      program_id: programId
    },
    dataType: 'json',
    method: 'GET',
    url: '/api/feedback_injections'
  }).then(response => {
    setFeedbackData(response, programId)
  })
}

function setFeedbackData(response, programId) {
  const currentPath = window.location.pathname
  const feedbacks = response          // array of feedbacks
  let programFeedbacks                //feedbacks related to program
  let matchedFeedbacks                //feedbacks related to current page

  programFeedbacks = filterFeedbacksByProgramId(feedbacks.items, programId) //feedbacks related to current program

  matchedFeedbacks = programFeedbacks.filter(item => {  // matching current program feedbacks with page URL
    const isMatch = picomatch(item.path)
    return isMatch(currentPath)
  })

  matchedFeedbacks.forEach(item => {     // check feedback and css_selector to put widget on page
    const selector = item.css_selector;

    waitForElement(selector, () => { // waiting DOM
      const elements = document.querySelectorAll(selector);

      elements.forEach((el) => {
        const uniqueWidgetId = uniqueId()
        const widget = document.createElement('sophia-feedback');
        widget.setAttribute('type', item.name);
        widget.setAttribute('cta', item.cta);
        widget.setAttribute('question', item.question);
        widget.setAttribute('placeholder', item.placeholder);
        widget.setAttribute('color', item.color);
        widget.setAttribute('data-id', item.name.replace(/ /g, "_") + uniqueWidgetId);
        widget.setAttribute('data-index', uniqueWidgetId);

        el.appendChild(widget)
      })
    })
  })
}

function filterFeedbacksByProgramId(feedbacks, programId) {
  return feedbacks.filter((item) => {
    return item.all_programs === true || item.program_ids.includes(programId);
  })
}

function waitForElement(selector, callback) {
  if (document.querySelector(selector)) {
    return callback();
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

$(() => {
  if (SOPHIA.loggedIn()) {
    initFeedbackInjector()
  }
})
